module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Light-520a955117e8e034d64a92435ce81ea7.woff2";